import { useEffect } from "react";

import { useTranslation } from "./i18n";

declare global {
  interface Window {
    subiz?: (...args: any[]) => void;
  }
}

export function ChatBubbleLocaleSync() {
  const { i18n, t } = useTranslation();

  useEffect(() => {
    const localeKey = i18n.language?.startsWith("en")
      ? "en_US"
      : i18n.language?.startsWith("zh")
        ? "zh_CN"
        : i18n.language?.startsWith("ja")
          ? "ja_JP"
          : i18n.language?.startsWith("ko")
            ? "ko_KR"
            : "vi_VN";
    const applyLocale = () => {
      if (typeof window.subiz !== "function") {
        return;
      }

      window.subiz("overrideChatbox", {
        type: "chatbox",
        chatbox: {
          caption: { [localeKey]: t("common.supportChatCaption") },
          tagline: { [localeKey]: t("common.supportChatTagline") },
          greeting: {
            agent_id: "agrzpexmwysrjwzisc",
            greeting: { [localeKey]: t("common.supportChatGreeting") },
          },
        },
      });
    };

    applyLocale();
    const retryTimer = window.setTimeout(applyLocale, 1000);
    return () => window.clearTimeout(retryTimer);
  }, [i18n.language, t]);

  return null;
}
